import React, { useState } from "react";
import UserAvatar from "../../../../components/user/UserAvatar";
import { DropdownToggle, DropdownMenu, Dropdown } from "reactstrap";
import { Icon } from "../../../../components/Component";
import { LinkList, LinkItem } from "../../../../components/links/Links";
import { handleSignout } from "../../../../utils/Utils";
import { Storage } from "../../../../services/storage/storage";

const User = () => {
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen((prevState) => !prevState);
  const user = Storage.getLoggedInUser();

  return (
    <>
      <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
        <DropdownToggle
          tag="a"
          href="#toggle"
          className="dropdown-toggle"
          onClick={(ev) => {
            ev.preventDefault();
          }}
        >
          <div className="user-toggle">
            <UserAvatar icon="user-alt" className="sm" />
          </div>
        </DropdownToggle>
        <DropdownMenu end className="dropdown-menu-md dropdown-menu-s1">
          <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
            <div className="user-card sm">
              <div className="user-info">
                <span className="lead-text">{user?.fullName ?? ""}</span>
                <span className="sub-text">{user?.email ?? ""}</span>
              </div>
            </div>
          </div>
          <div className="dropdown-inner">
            <LinkList>
              <LinkItem link={"/broadcast"} icon="bell" onClick={toggle}>
                Broadcast
              </LinkItem>
              <LinkItem link={"/check-password"} icon="setting-alt" onClick={toggle}>
                Change Password
              </LinkItem>
              <LinkItem link={"/login-activity"} icon="activity-alt" onClick={toggle}>
                Login Activity
              </LinkItem>
            </LinkList>
          </div>
          <div className="dropdown-inner">
            <LinkList>
              <a href={`${process.env.PUBLIC_URL}/auth-login`} onClick={handleSignout}>
                <Icon name="signout"></Icon>
                <span>Sign Out</span>
              </a>
            </LinkList>
          </div>
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default User;
